const TOOL_GROUP_LABELS: Record<string, string> = {
  "ui_component:add": "Adding components",
  "ui_component:configure": "Configuring components",
  "ui_component:delete": "Removing component",
  "ui_component:select": "Selecting component",
  "ui_component:move": "Moving component",
  "ui_component:clone": "Cloning component",
  "ui_component:reorder": "Reordering components",
  "ui_component:swap": "Swapping components",
  "ui_component:rename": "Renaming component",
  "ui_component:resize_column": "Resizing column",
  "ui_component:set_responsive_columns": "Setting responsive layout",
  "ui_style:set": "Styling components",
  "ui_style:apply_fixes": "Applying design fixes",
  "ui_style:review": "Reviewing design",
  "ui_style:screenshot": "Capturing screenshot",
  "ui_style:get_defaults": "Reading default styles",
  "ui_style:get_definition": "Reading component definition",
  "ui_style:list_colors": "Reading project colors",
  "ui_style:manage_color": "Managing project colors",
  "ui_screen_query:get_tree": "Reading screen structure",
  "ui_screen_query:get_info": "Inspecting component",
  "ui_screen_query:get_selected": "Checking selection",
  "ui_screen_query:list_available": "Listing components",
  "ui_screen_query:get_catalog": "Browsing catalog",
  "ui_screen_query:get_children": "Reading children",
  "ui_screen_query:get_events": "Reading events",
  "ui_screen_query:get_styles": "Reading styles",
  "ui_screen_query:get_multiple_styles": "Reading styles",
  "ui_screen_query:get_hierarchy": "Reading hierarchy",
  "ui_screen_query:find_by_name": "Finding components",
  "ui_property:list_binding_options": "Reading binding options",
  "ui_property:set_binding": "Binding data",
  "ui_property:set_symbol": "Setting property",
  "ui_property:update_symbol": "Updating property",
  "ui_property:set_type": "Setting property type",
  "ui_property:set_type_options": "Setting type options",
  "ui_property:get_data_editor": "Reading data editor",
  "ui_property:set_data_action": "Connecting datasource",
  "ui_property:set_data_field": "Binding data field",
  "ui_property:get_dynamic_types": "Reading dynamic types",
  "ui_action:add_to_event": "Adding action",
  "ui_action:add_multiple_to_event": "Adding actions",
  "ui_action:add_to_branch": "Adding branch action",
  "ui_action:create_conditional": "Creating conditional action",
  "ui_action:update_parameters": "Updating action parameters",
  "ui_action:update_properties": "Updating action properties",
  "ui_action:get_parameter_options": "Reading action parameters",
  "ui_action:get_parameter_editor_options": "Reading parameter editor",
  "ui_action:list_parameter_binding_options": "Reading parameter bindings",
  "ui_action:set_parameter_binding": "Setting parameter binding",
  "ui_action:list_screen_actions": "Listing actions",
  "ui_action:list_current_actions": "Listing actions",
  "ui_action:get_details": "Reading action details",
  "ui_action:delete_from_event": "Removing action",
  "ui_action:delete_from_branch": "Removing branch action",
  "ui_action:reorder": "Reordering actions",
  "ui_action:reorder_branch": "Reordering branch actions",
  "ui_action:add_condition": "Adding condition",
  "ui_action:set_condition": "Setting condition",
  "ui_action:remove_condition": "Removing condition",
  "ui_action:add_confirmation": "Adding confirmation",
  "ui_action:remove_confirmation": "Removing confirmation",
  "ui_action:export_clipboard": "Exporting action chain",
  "ui_action:paste_clipboard": "Pasting action chain",
  "ui_action_extended:add_to_for_each": "Adding to forEach",
  "ui_action_extended:set_for_each_data": "Setting forEach data",
  "ui_action_extended:add_to_mqtt": "Adding to MQTT",
  "ui_action_extended:set_mqtt_data": "Setting MQTT data",
  "ui_action_extended:add_recurring": "Adding recurring schedule",
  "ui_action_extended:add_to_recurring": "Adding to recurring",
  "ui_action_extended:set_recurring_data": "Setting recurring data",
  "ui_screen:list": "Listing screens",
  "ui_screen:get_current": "Checking current screen",
  "ui_screen:navigate": "Navigating to screen",
  "ui_screen:create": "Creating screen",
  "ui_screen:delete": "Deleting screen",
  "ui_screen:rename": "Renaming screen",
  "ui_screen:duplicate": "Duplicating screen",
  "ui_screen:create_folder": "Creating folder",
  "ui_screen:move_to_folder": "Moving screen to folder",
  "ui_screen_input:list": "Listing screen inputs",
  "ui_screen_input:create": "Creating screen input",
  "ui_screen_input:update": "Updating screen input",
  "ui_screen_input:delete": "Deleting screen input",
  "ui_validation:list": "Listing validations",
  "ui_validation:add": "Adding validation",
  "ui_validation:update": "Updating validation",
  "ui_validation:remove": "Removing validation",
  "ui_validation:validate_screen": "Validating screen",
  "ui_project:save": "Saving screen",
  "ui_project:reload_screen": "Reloading screen",
  "ui_project:reload_datasources": "Reloading datasources",
  "ui_project:reload_project": "Refreshing project",
  "ui_project:preview": "Starting preview",
  "ui_project:get_current_view": "Checking current view",
  "ui_project:navigate_to_view": "Switching view",
  "ui_project:set_left_panel": "Opening panel",
  "ui_project:set_right_panel": "Opening panel",
  "ui_project:list_datasources": "Listing datasources",
  "ui_project:get_datasource_actions": "Reading datasource actions",
  "ui_project:navigate_to_datasource": "Opening datasource",
  "ui_project:list_devices": "Listing devices",
  "ui_project:set_device": "Switching viewport",
  "ui_project:export_translations": "Exporting translations",
  "ui_project:export_excel_template": "Exporting Excel template",
  "ui_project_extended:list_comments": "Listing comments",
  "ui_project_extended:post_comment": "Posting comment",
  "ui_project_extended:reply_to_comment": "Replying to comment",
  "ui_project_extended:list_workflows": "Listing workflows",
  "ui_project_extended:navigate_to_workflow": "Opening workflow",
  ui_workflow_dsl: "Designing workflow",
  "ui_project_extended:list_scheduled_jobs": "Listing scheduled jobs",
  "ui_project_extended:navigate_to_scheduled_job": "Opening scheduled job",
  "ui_project_extended:list_apis": "Listing APIs",
  "ui_project_extended:get_api_details": "Reading API details",
  "ui_project_extended:navigate_to_api": "Opening API editor",
  "ui_project_extended:list_images": "Listing images",
  "ui_project_extended:upload_image": "Uploading image",
  "ui_project_extended:list_roles": "Listing roles",
  "ui_project_extended:create_role": "Creating role",
  "ui_project_extended:update_role": "Updating role",
  "ui_project_extended:delete_role": "Deleting role",
  "ui_project_extended:get_screen_authorization": "Reading selection authorization",
  "ui_project_extended:set_screen_authorization": "Setting selection authorization",
  "ui_project_extended:create_folder": "Creating folder",
  "ui_project_extended:rename_folder": "Renaming folder",
  "ui_project_extended:delete_folder": "Deleting folder",
  "ui_project_extended:add_item_to_folder": "Moving to folder",
  "ui_project_extended:create_subfolder": "Creating subfolder",
  "ui_project_extended:delete_subfolder": "Deleting subfolder",
  "ui_microapp:list_projects": "Listing MicroApp projects",
  "ui_microapp:list_screens": "Listing MicroApp screens",
  "ui_microapp:set_project": "Setting MicroApp project",
  "ui_microapp:set_starting_screen": "Setting MicroApp screen",
  "ui_history:undo": "Undoing last change",
  "ui_history:redo": "Redoing change",
  "ds_datasource:get_all": "Listing datasources",
  "ds_datasource:get_detail": "Reading datasource",
  "ds_datasource:save_swagger": "Importing datasource",
  "ds_datasource:delete": "Deleting datasource",
  "ds_sap:test_connection": "Testing SAP connection",
  "ds_sap:save_datasource": "Saving SAP datasource",
  "ds_sap:search_functions": "Searching SAP functions",
  "ds_sap:get_function_signature": "Reading SAP signature",
  "ds_sap:save_action": "Saving SAP action",
  "ds_csharp:get_template": "Reading C# template",
  "ds_csharp:save": "Saving C# datasource",
  "ds_action:delete": "Deleting action",
  "database_schema:get_schema_name": "Reading schema",
  "database_schema:get_tables": "Listing database tables",
  "database_schema:get_table_schema": "Reading table schema",
  "database_schema:execute_migration": "Running migration",
  "database_schema:get_column_types": "Reading column types",
  "db_sql_action:save_datasource": "Saving DB datasource",
  "db_sql_action:save_action": "Saving SQL action",
  "db_sql_action:get_parameter_types": "Reading parameter types",
  "database_data:seed": "Seeding demo data",
  "database_data:list_seedable": "Listing seedable tables",
  "translation:get_supported_languages": "Listing languages",
  "translation:add_language": "Adding language",
  "translation:get_project_languages": "Reading project languages",
  "translation:get_all": "Listing translations",
  "translation:save": "Saving translation",
  "translation:delete_all": "Deleting translations",
  "translation:delete_screen": "Deleting screen translations",
  "translation:set_default": "Setting default language",
  "translation:remove_language": "Removing language",
  "scheduler_job:create": "Creating scheduled job",
  "scheduler_job:update": "Updating scheduled job",
  "scheduler_job:get_all": "Listing scheduled jobs",
  "scheduler_job:get_detail": "Reading job details",
  "scheduler_job:activate": "Activating scheduled job",
  "scheduler_job:inactivate": "Deactivating scheduled job",
  "scheduler_job:delete": "Deleting scheduled job",
  "package_management:get_available": "Listing packages",
  "package_management:search_nuget": "Searching NuGet",
  "package_management:install": "Installing package",
  "package_management:update": "Updating package",
  "package_management:uninstall": "Uninstalling package",
  "common:generate_guids": "Generating GUIDs",
  "common:get_all_actions": "Listing action names",
  "common:get_action_detail": "Reading action definition",
  "common:check_existing_names": "Checking names",
  "lsp_csharp:get_diagnostics": "Running C# diagnostics",
  "lsp_csharp:format_code": "Formatting C# code",
  ui_render: "Building components",
  crud_create_screen_by_table_name: "Creating CRUD screen",
  plan_progress: "Plan progress",
  search_documentation: "Searching docs",
  ui_common_ask_user_question: "Asking question"
};

export function getToolGroupLabel(toolName: string, input: Record<string, any> | undefined): string | undefined {
  const operation = input?.operation;
  if (typeof operation === "string") {
    const composite = TOOL_GROUP_LABELS[`${toolName}:${operation}`];
    if (composite) return composite;
  }
  if (toolName.startsWith("batch(")) return TOOL_GROUP_LABELS.ui_render;
  return TOOL_GROUP_LABELS[toolName];
}

export function isRenderToolGroup(toolName: string, input: Record<string, any> | undefined): boolean {
  return getToolGroupLabel(toolName, input) === TOOL_GROUP_LABELS.ui_render;
}

export { TOOL_GROUP_LABELS };
